export default __webpack_public_path__ + "static/media/sponsor_300x250_v2.3083c58e.jpg";